import React, { Component } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import AnalysisTools from '../../utils/AnalysisTools';
import { IconButton, Tooltip } from '@mui/material';
import { Repeat } from '@mui/icons-material';
import { Chip } from '@mui/material';
import { connect } from 'react-redux';
import { showError, showMessage, confirmAction } from '../../actions/uiActions';
import { CircularProgress } from '@mui/material';
import Icon from '@mdi/react';
import { mdiCalendarEdit } from '@mdi/js';
import DateEdit from './components/DateEdit';
import moment from 'moment';
import FormsApi from '../../api/forms';
import PSLFEmployerDetails from '../PSLFEmployerDetails';
import RecertificationDates from './components/RecertificationDates';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
class UserDates extends Component {
  state = {
    edit: null,
    editing: [],
    assigning: []
  };

  noImportantDates = () => {
    return (
      <TableRow>
        <TableCell colSpan="4" className="text-center">
          This user does not have any important dates.
        </TableCell>
      </TableRow>
    );
  };

  renderEvent = (action, actionable) => {
    let color = 'default';
    let label = '';
    switch (action) {
      case 'completed':
        label = 'Form Signed';
        break;
      case 'submited':
        label = 'Sent to Servicer';
        if (actionable) {
          color = 'primary';
        }
        break;
    }
    return <Chip label={label} color={color} />;
  };

  editDate = form => {
    this.setState({ edit: form });
  };
  canRecert = form => {
    const duplicated = this.props.account.forms.find(
      f => f.form === form.form && !f.live
    );
    return duplicated ? false : true;
  };
  reassign = form => {
    const formInfo = { ...form };
    this.props.confirmAction(
      'You are going to re-assign this form to the user for recertification, do you want to proceed?',
      () => {
        this.setState(
          {
            assigning: [...this.state.assigning, form.id]
          },
          async () => {
            try {
              const form = await FormsApi.assignForm(
                this.props.account._id,
                formInfo.form,
                formInfo.servicer,
                null,
                formInfo.signature,
                formInfo.notes,
                true
              );
              this.props.showMessage('The form has been assigned to the user.');
              this.props.onFormAssigned(form);
              this.setState({
                assigning: this.state.assigning.filter(
                  f => f.id !== formInfo.id
                )
              });
            } catch (error) {
              console.log(error);
              this.setState(
                {
                  assigning: this.state.assigning.filter(f => f.id !== form.id)
                },
                this.props.showError
              );
            }
          }
        );
      }
    );
  };
  renderImportantDate = (form, key) => {
    const formInfo = this.props.account.forms.find(f => f.id === form.id);
    return (
      <TableRow key={`important-date-${key}`}>
        <TableCell>
          <span>{form.name}</span>
          <div className="form-notes">
            {(form.form == 2 || form.form == 3) && form.employer && (
              <PSLFEmployerDetails employer={form.employer} />
            )}
          </div>
        </TableCell>
        <TableCell>{this.renderEvent(form.event, form.actionable)}</TableCell>
        <TableCell className="text-center">{form.date}</TableCell>
        <TableCell className="text-center">
          {form.approvedDate
            ? moment(form.approvedDate, 'X').format('MM/DD/YYYY')
            : ''}
        </TableCell>
        <TableCell className="text-center">
          {form.rejectedDate
            ? moment(form.rejectedDate, 'X').format('MM/DD/YYYY')
            : ''}
        </TableCell>
        {/* <TableCell className="text-center">
                {form.actionable&&this.canRecert(formInfo)&&<Tooltip title="Re-assign form for recertification">
                    <IconButton onClick={()=>this.reassign(formInfo)}>
                        <Repeat />
                    </IconButton>
                </Tooltip>}
                {form.actionable&&!this.state.editing.includes(form.id)&&<Tooltip title="Edit event date">
                    <IconButton onClick={()=>this.editDate(form)}>
                        <Icon path={mdiCalendarEdit} size={1} />
                    </IconButton>
                </Tooltip>}
                {this.state.editing.includes(form.id)&&<CircularProgress size={16} />}
            </TableCell> */}
      </TableRow>
    );
  };
  render() {
    const forms = AnalysisTools.getImportantDates(this.props.account);

    return (
      <div className="col-12 margin-bottom20px padding-bottom20px">
        {
        this.props.account.loanType !== 'private' ? (
          <>
            <RecertificationDates
              user={this.props.account}
              idr={this.props.account.idr_recertification}
              pslf={this.props.account.pslf_recertifications}
              tlf={this.props.account.tlf_recertification ?? ''}
              onRecertificationDateUpdated={this.props.onRecertificationDateUpdated}
            />
            <Accordion>
              <AccordionSummary>Event dates</AccordionSummary>
              <AccordionDetails>
                <Table>
                  <TableHead>
                    <TableCell className="width40pct">Form Name</TableCell>
                    <TableCell className="width15pct ">Event</TableCell>
                    <TableCell className="width15pct text-center">
                      Event Date
                    </TableCell>
                    <TableCell className="width15pct text-center">
                      Approved Date
                    </TableCell>
                    <TableCell className="width15pct text-center">
                      Rejected Date
                    </TableCell>
                  </TableHead>
                  <TableBody>
                    {forms.length === 0 && this.noImportantDates()}
                    {forms.map((form, index) =>
                      this.renderImportantDate(form, index)
                    )}
                  </TableBody>
                </Table>
              </AccordionDetails>
            </Accordion>
          </>
        ) : (
          <div className="col-12">
            <p className="text-center">
              This view is not available to this user because he/she as private
              loan
            </p>
          </div>
        )}

        <div className="line-break"></div>
      </div>
    );
  }
}
export default connect(null, { showError, showMessage, confirmAction })(
  UserDates
);
